import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, CircularProgress } from '@mui/material';

class RemoteButton extends React.PureComponent {
    state = {
        showDialog: false,
        running: false,
    };

    componentWillUnmount() {
        this.destroyed = true;
    }

    closeDialog = () => {
        this.setState({ showDialog: false });
    }

    showDialog = () => {
        this.setState({ showDialog: true });
    }

    start = async () => {
        this.setState({ running: true });
        await this.props.onStart(this);
        if (this.destroyed) {
            return;
        }
        this.setState({ running: false });
    }

    render() {
        return (
            <div style={{ display: 'inline' }}>
                <Dialog open={this.state.showDialog} onClose={this.closeDialog}>
                    <DialogTitle>{this.props.title || this.props.name}</DialogTitle>
                    <DialogContent>
                        {this.props.children}
                    </DialogContent>
                    <DialogActions>
                        {
                            this.state.running &&
                            <CircularProgress />
                        }
                        {
                            !this.state.running &&
                            <div>
                                <Button variant="contained" onClick={this.closeDialog}>Cancel</Button>
                                <Button variant="contained" onClick={this.start}>OK</Button>
                            </div>
                        }
                    </DialogActions>
                </Dialog>
                <Button color="primary" onClick={this.showDialog}>{this.props.name}</Button>
            </div>
        );
    }
}

RemoteButton.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    children: PropTypes.any,
    onStart: PropTypes.func.isRequired,
};

export default RemoteButton;